import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, TextField, Button, Table, TableBody, TableCell, TableHead, TableRow, Paper, IconButton, Alert } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../api';

function SubjectsAdmin() {
  const [subjects, setSubjects] = useState([]);
  const [name, setName] = useState('');
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const fetchSubjects = async () => {
    try {
      const res = await api.get('/api/subjects');
      setSubjects(res.data || []);
    } catch (err) {
      setError('Failed to load subjects');
    }
  };

  useEffect(() => { fetchSubjects(); }, []);

  const handleSave = async () => {
    setError(''); setSuccess('');
    if (!name.trim()) { setError('Name required'); return; }
    try {
      if (editId) {
        await api.put(`/api/subjects/${editId}`, { name });
        setSuccess('Subject updated');
      } else {
        await api.post('/api/subjects', { name });
        setSuccess('Subject created');
      }
      setName(''); setEditId(null); fetchSubjects();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save subject');
    }
  };

  const handleEdit = (s) => { setName(s.name); setEditId(s._id); setError(''); setSuccess(''); };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this subject?')) return;
    try {
      await api.delete(`/api/subjects/${id}`);
      setSuccess('Subject deleted');
      fetchSubjects();
    } catch (err) {
      setError('Failed to delete subject');
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Subjects</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <TextField label="Subject name" value={name} onChange={e => setName(e.target.value)} fullWidth />
        <Button variant="contained" onClick={handleSave}>{editId ? 'Update' : 'Add'}</Button>
        {editId && <Button variant="outlined" onClick={() => { setEditId(null); setName(''); }}>Cancel</Button>}
      </Box>

      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subjects.map(s => (
              <TableRow key={s._id}>
                <TableCell>{s.name}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEdit(s)}><EditIcon /></IconButton>
                  <IconButton onClick={() => handleDelete(s._id)}><DeleteIcon /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
}

export default SubjectsAdmin;
